module.exports = __webpack_public_path__ + "static/media/raduno1980.142063bd.jpg";